import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as moment from "moment";
import {initAxios, initAuth} from "./utils/init";

Vue.router = router;
Vue.config.productionTip = false;

initAxios('https://api.vinesite.net');
//initAuth();
//https://github.com/rtivital/proschet
moment.locale('ru');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');


document.addEventListener('touchmove', (e) => {
  if (e.scale !== 1) e.preventDefault(); //Block scale Safari
}, false);
